import React, { Fragment } from 'react';
import T from 'prop-types';
// components
import RecoverySection from './RecoverySection';
import PersonalValues from './PersonalValues';
// utils
import isEmpty from 'lodash.isempty';
// styles
import styles from './Triggers.mod.css';
import EditIcon from './EditIcon';

const Triggers = ({ placeholder, userColor, triggers }) => {
  const editLinks = {
    external: {
      pathname: '/module/1',
      state: { step: 0 },
    },
    internal: {
      pathname: '/module/1',
      state: { step: 2 },
    },
  };
  return (
    <RecoverySection
      title="My Triggers"
      placeholder={`${placeholder} 1`}
      userColor={userColor}
    >
      {triggers ? (
        <Fragment>
          {Object.keys(triggers).map(key => (
            <Fragment key={key}>
              {!isEmpty(triggers[key].plain) && (
                <Fragment>
                  <div className={styles.heading}>
                    <h4>{key}</h4>
                    <EditIcon color={userColor} editLink={editLinks[key]} />
                  </div>
                  <ul>
                    {triggers[key].plain.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </Fragment>
              )}
              {!isEmpty(triggers[key].personal) && (
                <PersonalValues
                  title={`Personal ${key} triggers`}
                  field="my_trigger"
                  data={triggers[key].personal}
                  userColor={userColor}
                />
              )}
            </Fragment>
          ))}
        </Fragment>
      ) : null}
    </RecoverySection>
  );
};

Triggers.propTypes = {
  placeholder: T.string,
  triggers: T.object,
  userColor: T.string,
};

export default React.memo(Triggers);



// WEBPACK FOOTER //
// ./src/containers/RecoveryPlan/components/Triggers.jsx